import { noddiAsync, URLKeys } from 'noddi-async';

export const normalizeOrganizationNumber = (value: string) => value.replace(/\s/g, '');

export const useCompanyLookup = (registrationNumber: string) => {
  const digits = normalizeOrganizationNumber(registrationNumber);
  const valid = /^\d{9}$/.test(digits);
  const query = noddiAsync.useGet({
    type: URLKeys.getCompanyLookup,
    input: { organizationNumber: valid ? parseInt(digits, 10) : 0 },
    queryConfig: { enabled: false }
  });
  return {
    ...query,
    canLookup: valid,
    data: query.data && normalizeOrganizationNumber(query.data.organizationNumber) === digits ? query.data : undefined
  };
};
